import { EmailMessageStatus } from "./email-message-status.model";

export class EmailMessage {
  EmailMessageId: number;
  RecipientEmailAddress: string;
  Subject: string;
  Body: string;
  CreatedAt: Date;
  SentAt: Date;
  Status: EmailMessageStatus;
  HasError: boolean;
  ErrorMessage: string;

  constructor() {
    this.EmailMessageId = null;
    this.RecipientEmailAddress = null;
    this.Subject = null;
    this.Body = null;
    this.CreatedAt = null;
    this.SentAt = null;
    this.HasError = false;
    this.ErrorMessage = null;
  }
}

export let EmailMessageIgnoreList: any[] = [
  "EmailMessageStatus"
];
